<template>
    <b-container fluid>
        <b-row align-v="start">
            <b-col cols="12" md="4" lg="4">
                <app-form-input
                    type="date"
                    label="Desde"
                    v-model="filters.from"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-form-input
                    type="date"
                    label="Hasta"
                    v-model="filters.to"
                ></app-form-input>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-autocomplete
                    :items="clients"
                    label="Cliente"
                    v-model="filters.clientId"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-autocomplete
                    :items="administrativeUsers"
                    label="Usuario"
                    v-model="filters.userId"
                    :get-object="false"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-form-select-input
                    :options="petitionTypes"
                    v-model="filters.petitionTypeId"
                    label="Tipo"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-form-select-input
                    :options="petitionStatuses"
                    v-model="filters.petitionStatusId"
                    label="Estado"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-form-select-input
                    :options="categories"
                    v-model="filters.petitionCategoryId"
                    label="Categoría"
                    @change="loadSubCategories"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="4" lg="4">
                <app-form-select-input
                    :options="subCategories"
                    v-model="filters.petitionSubCategoryId"
                    label="SubCategoría"
                ></app-form-select-input>
            </b-col>
            <b-col class="right-spaced">
                <b-btn variant="primary" @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn variant="secondary" @click="clearFilter"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data: () => ({
        filters: {
            from: '',
            to: '',
            clientId: '',
            userId: '',
            petitionTypeId: '',
            petitionStatusId: '',
        },
        categories: [],
        subCategories: [],
    }),
    computed: {
        ...mapGetters([
            'years',
            'months',
            'clients',
            'administrativeUsers',
            'petitionTypes',
            'petitionStatuses',
        ]),
    },
    methods: {
        filter() {
            this.$emit('filter', this.filters)
        },
        clearFilter() {
            _.forIn(this.filters, (v, k) => (this.filters[k] = ''))
            this.$emit('filter', null)
        },
        loadCategories() {
            repo.get('petitions/categories').then(
                ({ data }) => (this.categories = data)
            )
        },
        loadSubCategories(categoryId) {
            repo.get('petitions/sub-categories', { category: categoryId }).then(
                ({ data }) => (this.subCategories = data)
            )
        },
    },
    mounted() {
        this.load('clients')
        this.load('years')
        this.load('months')
        this.load('administrativeUsers')
        this.load('petitionTypes')
        this.load('petitionStatuses')
        this.loadCategories()
    },
}
</script>
